var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserDue = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3H2.75A2.752 2.752 0 0 0 0 5.75v12.5A2.752 2.752 0 0 0 2.75 21h18.5A2.752 2.752 0 0 0 24 18.25V5.75A2.752 2.752 0 0 0 21.25 3zM7.5 7C8.878 7 10 8.122 10 9.5S8.878 12 7.5 12 5 10.878 5 9.5 6.122 7 7.5 7zm4.5 9.25a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.5A2.752 2.752 0 0 1 5.75 13h3.5A2.752 2.752 0 0 1 12 15.75zm8.25.75h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5zm0-4h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5zm0-4h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5z",
    opacity: 1,
    "data-original": "#000000"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserDue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userDue.a7c6c6f6.svg";
export { ForwardRef as ReactComponent };